import React from 'react';
import styled from 'styled-components';
import { Box } from '../../Box/Box';
const Stage = /*#__PURE__*/styled(Box).withConfig({
  displayName: "StoryStage__Stage",
  componentId: "sc-1juj7he-0"
})(["> *{margin:16px;}"]);
/**
 * @public
 */
export const StoryStage = ({
  children,
  ...rest
}) => React.createElement(Stage, {
  ...rest
}, children);